import site from "@/data/site.json";

export default function Marquee() {
    const items = site.marquee;
    return (
        <section
            data-testid="marquee-section"
            aria-label="Destaques do pet shop"
            className="relative overflow-hidden border-y border-forest-light/40 bg-forest py-5"
        >
            <div className="group flex w-max animate-marquee items-center gap-10 pr-10 group-hover:[animation-play-state:paused]">
                {[0, 1].map((copy) => (
                    <div
                        key={copy}
                        aria-hidden={copy === 1}
                        className="flex items-center gap-10 pr-10"
                    >
                        {items.map((item) => (
                            <span
                                key={`${copy}-${item}`}
                                className="flex items-center gap-10 whitespace-nowrap text-sm font-bold uppercase tracking-[0.24em] text-cream/90"
                            >
                                {item}
                                <svg viewBox="0 0 24 24" className="h-4 w-4 fill-coral" aria-hidden="true">
                                    <path d="M12 2c1.2 3 2.6 4.4 5.5 5.6-2.9 1.2-4.3 2.6-5.5 5.6-1.2-3-2.6-4.4-5.5-5.6C9.4 6.4 10.8 5 12 2zM6 14c.8 2 1.7 2.9 3.7 3.7-2 .8-2.9 1.7-3.7 3.7-.8-2-1.7-2.9-3.7-3.7 2-.8 2.9-1.7 3.7-3.7z" />
                                </svg>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </section>
    );
}
